module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"media_summary_title":"Photos&Videos","show_all":"See all"}}')
  delete Component.options._Ctor
}
